module.exports = __webpack_public_path__ + "img/hit.1cc1ac58.jpg";